import { createAsyncThunk } from '@reduxjs/toolkit';
import i18n from '../../../i18n';

import type {
  CheckEmailCommand,
  CheckEmailResponse,
  SignInCommand,
  SignUpCommand,
  SignUpResponse,
} from '../Domain/repository/AuthRepository';
import type { AuthSession } from '../Domain/entity/AuthTypes';
import { authUseCases } from './authUseCases';

export const signIn = createAsyncThunk<AuthSession, SignInCommand, { rejectValue: string }>(
  'auth/signIn',
  async (command, { rejectWithValue }) => {
    try {
      return await authUseCases.signIn.execute(command);
    } catch (error) {
      return rejectWithValue((error as Error).message ?? i18n.t('common.repositoryErrors.authSignInFailed'));
    }
  },
);

export const signUp = createAsyncThunk<SignUpResponse, SignUpCommand, { rejectValue: string }>(
  'auth/signUp',
  async (command, { rejectWithValue }) => {
  try {
      return await authUseCases.signUp.execute(command);
  } catch (error) {
      return rejectWithValue((error as Error).message ?? i18n.t('common.repositoryErrors.authSignUpFailed'));
  }
  },
);

export const checkEmail = createAsyncThunk<CheckEmailResponse, CheckEmailCommand, { rejectValue: string }>(
  'auth/checkEmail',
  async (command, { rejectWithValue }) => {
    try {
      return await authUseCases.checkEmail.execute(command);
    } catch (error) {
      return rejectWithValue((error as Error).message ?? i18n.t('common.repositoryErrors.checkEmailFailed', { code: 'unknown' }));
    }
  },
);

